import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitPrescriptionsDetails = ({
  prescriptions,
  prescriptionsRef,
  handleFileDownload,
}) => {
      console.log("VisitPrescriptionsDetails")

  if (!Array.isArray(prescriptions) || prescriptions.length === 0) return null;

  return (
    <div ref={prescriptionsRef}>
      {prescriptions.map((prescription, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Receptas</Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(prescription.dateAsserted)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(prescription.dateAsserted)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(prescription.dateAsserted)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Pavadinimas: </span>
              <span>{prescription.name}</span>
            </div>

            <div>
              <span>Diagnozė: </span>
              <span>{prescription.reason}</span>
            </div>

            <div>
              <span>Kompensacijos rūšis: </span>
              <span>
                {prescription.coverage === null
                  ? 'Nekompensuojama'
                  : prescription.coverage}
              </span>
            </div>

            <div>
              <span>Dozavimo rekomendacijos: </span>
              <span>{prescription.dosage || '-'}</span>
            </div>

            <div>
              <span>Galioja nuo: </span>
              <span>
                {new Date(Date.parse(prescription.effectiveStartDate)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(prescription.effectiveStartDate)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(prescription.effectiveStartDate)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Galioja iki: </span>
              <span>
                {new Date(Date.parse(prescription.effectiveEndDate)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(prescription.effectiveEndDate)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(prescription.effectiveEndDate)}
                  </Moment>
                )}
              </span>
            </div>

            {prescription.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${prescription.name} ${moment(
                      new Date(prescription.dateAsserted),
                    ).format('YYYY-MM-DD')}`;
                    handleFileDownload(
                      'Prescription',
                      fileName,
                      prescription.file.type,
                      prescription.file.guid
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>
          <CardFooter />
        </Card>
      ))}
    </div>
  );
};
